<template>
  <!-- eslint-disable -->
  <div style="text-align:left;">
  <div class="column-left">
    <SideNav />
  </div>
  <div >
    <ModalModificarProfesional ref="modalmodificarprofesional" />
    <div class="column-right">
      <TopNav />
      <div class="main-container">   
        
        <div v-if="loaded" class="professionals-container">
          <!-- Header Section -->
          <div class="page-header">
            <div class="header-content">
              <div class="title-section">
                <div class="page-icon" :style="{
                  backgroundImage: `linear-gradient(139deg, ${prestador.admin.assets.colors.primary} 0%, ${prestador.admin.assets.colors.secondary} 100%)`
                }">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                    <circle cx="8.5" cy="7" r="4"></circle>
                    <path d="M20 8v6"></path>
                    <path d="M23 11h-6"></path>
                  </svg>
                </div>
                <div>
                  <h1 class="page-title">Profesionales Clínicos</h1>
                  <p class="page-subtitle">Configuración de Perfiles de Profesionales a Domicilio</p>
                </div>
              </div>
              
              <div class="action-buttons">
                <router-link
                  tag="button"
                  to="/CrearProfesional"
                  v-if="true"
                  class="primary-action-btn"
                  :style="{
                  backgroundImage: `linear-gradient(139deg, ${prestador.admin.assets.colors.primary} 0%, ${prestador.admin.assets.colors.secondary} 100%)`
                }"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="8" x2="12" y2="16"></line>
                    <line x1="8" y1="12" x2="16" y2="12"></line>
                  </svg>
                  Crear profesional
                </router-link>
                <router-link
                  tag="button"
                  class="secondary-action-btn"
                  :style="{'border-color': prestador.admin.assets.colors.primary, 'color': prestador.admin.assets.colors.primary}"
                  to="/BloqueosHorario"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="12" cy="12" r="10"></circle>
                    <polyline points="12,6 12,12 16,14"></polyline>
                  </svg>
                  Bloqueos Horario
                </router-link>
                <button
                  v-if="prestador.id == 1"
                  class="secondary-action-btn"
                  @click="descargarExcel"
                  :style="{'border-color': prestador.admin.assets.colors.secondary, 'color': prestador.admin.assets.colors.secondary}"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                    <polyline points="7,10 12,15 17,10"></polyline>
                    <line x1="12" y1="15" x2="12" y2="3"></line>
                  </svg>
                  Descargar Excel
                </button>
              </div>
            </div>
          </div>

          <!-- Professionals Grid -->
          <div class="professionals-grid">
            <div v-for="p in profesionales" :key="p.id" class="professional-card">
              <!-- Card Header -->
              <div class="card-header" @click="p.viendo = !p.viendo">
                <div class="professional-avatar">
                  <div 
                    class="avatar-image"
                    :style="{
                      'background-image': p.atributos && p.atributos.hasOwnProperty('foto') 
                        ? 'url(https://assets-fotos-profesionales.s3.sa-east-1.amazonaws.com/'+p.atributos.foto+')' 
                        : 'url(' +require('@/assets/ia/emptyuser.webp')+ ')',
                      'border-color': p.viendo ? prestador.admin.assets.colors.primary : '#e2e8f0'
                    }"
                  ></div>
                  <div v-if="p.prestador_id != prestador.id" class="external-badge" :style="{'background-color': prestador.admin.assets.colors.secondary}">
                    Externo
                  </div>
                </div>
                
                <div class="professional-info">
                  <div class="professional-name">
                    <h3>{{ p.nombre }} {{ p.apellido }}</h3>
                    <div class="professional-status" :style="{'color': prestador.admin.assets.colors.primary}">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <circle cx="12" cy="12" r="3"></circle>
                        <path d="M12 1v6m0 6v6m11-7h-6m-6 0H1"></path>
                      </svg>
                      Activo
                    </div>
                  </div>
                  
                  <div class="professional-details">
                    <div class="detail-item">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                        <polyline points="22,6 12,13 2,6"></polyline>
                      </svg>
                      <span>{{ p.email }}</span>
                    </div>
                    
                    <div v-if="p.atributos && p.atributos.empresa" class="detail-item">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9,22 9,12 15,12 15,22"></polyline>
                      </svg>
                      <span>{{ p.atributos.empresa }}</span>
                    </div>
                  </div>
                </div>
                
                <div class="expand-indicator">
                  <svg 
                    width="20" 
                    height="20" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    stroke-width="2"
                    :style="{'transform': p.viendo ? 'rotate(180deg)' : 'rotate(0deg)'}"
                  >
                    <path d="M6 9l6 6 6-6"></path>
                  </svg>
                </div>
              </div>

              <!-- Card Actions -->
              <div class="card-actions">
                <button 
                  v-if="p.prestador_id == prestador.id" 
                  @click="$refs.modalmodificarprofesional.show(p)" 
                  class="action-btn edit-btn"
                  :style="{'color': prestador.admin.assets.colors.primary}"
                  title="Editar profesional"
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                  </svg>
                </button>
                
                <router-link v-if="p.prestador_id == prestador.id" :to="'/Profesional/'+p.id">
                  <button 
                    class="action-btn calendar-btn"
                    :style="{'color': prestador.admin.assets.colors.primary}"
                    title="Ver calendario"
                  >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                      <line x1="16" y1="2" x2="16" y2="6"></line>
                      <line x1="8" y1="2" x2="8" y2="6"></line>
                      <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                  </button>
                </router-link>
                
                <button 
                  v-if="p.prestador_id == prestador.id" 
                  @click="enviarAppProfesional(p.id)" 
                  class="action-btn mobile-btn"
                  :style="{'color': prestador.admin.assets.colors.primary}"
                  title="Enviar app móvil"
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="7" y="2" width="10" height="20" rx="2" ry="2"></rect>
                    <path d="M11 5h2" /> <!-- notch o cámara superior -->
                  </svg>
                </button>

                <button 
                  v-if="p.prestador_id == prestador.id" 
                  @click="deleteProfesionalDialogue(p.id)" 
                  class="action-btn delete-btn"
                  title="Eliminar profesional"
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="3,6 5,6 21,6"></polyline>
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                  </svg>
                </button>
                
                <confirm-dialogue :ref="'confirmDialogueProfesional' + p.id" />
              </div>

              <!-- Expanded Details -->
              <div v-if="p.viendo" class="card-details">
                <div class="details-grid">
                  <!-- Comunas Section -->
                  <div class="detail-section">
                    <div class="section-header">
                      <div class="section-icon" :style="{'background-color': prestador.admin.assets.colors.secondary}">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                          <circle cx="12" cy="10" r="3"></circle>
                        </svg>
                      </div>
                      <h4 class="section-title">Comunas de Atención</h4>
                    </div>
                    <div class="tags-container">
                      <span 
                        v-for="c in p.comunas" 
                        :key="c"
                        class="tag location-tag"
                        :style="{'background-color': prestador.admin.assets.colors.secondary + '20', 'color': prestador.admin.assets.colors.secondary}"
                      >
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                          <circle cx="12" cy="10" r="3"></circle>
                        </svg>
                        {{ comunas.find(x=>x.id==c).Nombre }}
                      </span>
                    </div>
                  </div>

                  <!-- Categorías Section -->
                  <div class="detail-section">
                    <div class="section-header">
                      <div class="section-icon" :style="{'background-color': prestador.admin.assets.colors.primary}">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                          <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
                        </svg>
                      </div>
                      <h4 class="section-title">Especialidades</h4>
                    </div>
                    <div class="tags-container">
                      <span 
                        v-for="c in p.categorias" 
                        :key="c"
                        class="tag specialty-tag"
                        :style="{'background-color': prestador.admin.assets.colors.primary + '20', 'color': prestador.admin.assets.colors.primary}"
                      >
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                          <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
                        </svg>
                        {{ categorias.find(x=>x.id==c).nombre }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Loading State -->
        <div v-else class="loading-container">
          <div class="loading-content">
            <Loader :height="100" :width="100" />
            <h3>Cargando profesionales...</h3>
            <p>Por favor espere mientras obtenemos la información</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios';
import {mapGetters, mapActions} from 'vuex';
import ConfirmDialogue from './utils/ConfirmDialogue.vue';
import Fuse from 'fuse.js'
import SideNav from '@/components/SideNav.vue';
import Loader from '@/components/Loader.vue';
import TopNav from '@/components/TopNav.vue';
import ModalModificarProfesional from './utils/ModalModificarProfesional.vue';
import fetchData from '@/helpers/fetchData.js'
import * as XLSX from 'xlsx';



export default {
  name: 'HelloWorld',
  props:['id'],
  components: {
    SideNav,
    Loader,
    TopNav,
    ModalModificarProfesional,
    ConfirmDialogue,
  },
  data() {
    return {
      loaded:false,
      profesionales:[],


    }
  },
  created(){
  
    this.initialize_(this.$route.params.id);
  },

  methods:{
    ...mapActions(['initialize']),

    descargarExcel() {
      const data = this.profesionales.map(p => {
        // Obtener nombres de comunas
        const nombresComunas = p.comunas ? p.comunas.map(cId => {
          const comuna = this.comunas.find(x => x.id == cId);
          return comuna ? comuna.Nombre : cId;
        }).join(', ') : '';

        // Obtener nombres de categorías
        const nombresCategorias = p.categorias ? p.categorias.map(cId => {
          const cat = this.categorias.find(x => x.id == cId);
          return cat ? cat.nombre : cId;
        }).join(', ') : '';

        return {
          'ID': p.id,
          'Nombre': p.nombre,
          'Apellido': p.apellido,
          'Email': p.email,
          'Empresa': p.atributos && p.atributos.empresa ? p.atributos.empresa : '',
          'Comunas': nombresComunas,
          'Especialidades': nombresCategorias,
          'Estado': 'Activo'
        };
      });

      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Profesionales");
      XLSX.writeFile(wb, "profesionales.xlsx");
    },

    mostrar_modal_horario(){

    },

    async deleteProfesionalDialogue(profesional_id) {
      const profesional = this.profesionales.filter(x=>{return x.id == profesional_id})[0];
      const confirmDialogue = this.$refs["confirmDialogueProfesional" + profesional_id][0];
      const ok = await confirmDialogue.show({
        title: `¿Eliminar profesional ${profesional.nombre} ${profesional.apellido}?`,
        message: 'Se eliminará el profesional y no podrá recuperarse.',
        okButton: 'Eliminar definitivamente',
      })
      // If you throw an error, the method will terminate here unless you surround it wil try/catch
      if (ok) {
        await this.eliminar_profesional(profesional_id);
      } else {
        alert('Se canceló la eliminación.')
      }
    },
    async enviarAppProfesional(profesional_id) {
       axios({url: window.hostname+'/api/admin/enviar_app_profesional', method: 'POST', data:{profesional_id: profesional_id}})
      .then((data)=>{
        alert('¡Se le ha enviado el enlace al profesional!')
        this.$notify({duration:5000, title: 'Enlace enviado', text: '¡Se le ha enviado el enlace al profesional!', type: 'success'})
      })
      .catch((error)=> {
        alert('Ha ocurrido un error...')
        this.$notify({duration:5000, title: 'Error', text: 'Ha ocurrido un error...', type: 'error'})
      })
    },

    getProfesionales(){
      this.loaded = false;
      this.profesionales = [];
      axios({url: window.hostname+'/api/admin/getprofesionales', method:'GET'})
      .then((r)=>{
        
        for(var p of r.data.profesionales){
          p.viendo = false;
          this.profesionales.push(p);
        }
        this.loaded = true;
      })
      .catch((error)=> {
        this.loaded = true;
      })
    },
    async eliminar_profesional(hid){
      
      await axios({url: window.hostname+'api/admin/eliminar_profesional', method:'POST', data:{profesional_id: hid}})
      .then((response) => {
        this.getProfesionales();
        alert('Se eliminó el profesional.')
      })
      .catch((e)=>{
        alert('Error al eliminar el profesional.')
      })
    },
    async descargarExcel() {
      try {
        const response = await axios({
          url: window.hostname + '/api/admin/exportar_profesionales_excel',
          method: 'POST',
          responseType: 'blob' // Importante para manejar archivos binarios
        });

        // Crear un link temporal para la descarga
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        const fecha = new Date().toISOString().split('T')[0];
        link.setAttribute('download', `profesionales_${fecha}.xlsx`);
        document.body.appendChild(link);
        link.click();
        
        // Limpiar
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error al descargar el Excel:', error);
        alert('Hubo un error al generar el archivo Excel.');
      }
    }

  },
  computed:{
    ...mapGetters(['comunas', 'categorias', 'regiones', 'prestaciones', 'tipos', 'admin_datos', 'prestador']),
  },
  mounted() {
    this.getProfesionales()
    this.$root.$on('recargar_profesionales', () => {
      this.getProfesionales();
});
  },
  watch:{
    comunas_buscadas(val){
      this.resultado_fuse_comuna = this.fComunas.search(val)

    },
  }

}
</script>


<style scoped>
/* Base Styles - Notion-inspired with medical touches */

.column-right {
  background-color: var(--background-primary);
  padding-top: 0px;
  padding-left: 275px;
  width: 100%;
  min-height: 100vh;
}

.professionals-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  padding: 2rem;
}

/* Page Header */
.page-header {
  background: white;
  border-radius: 16px;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
  border: 1px solid #e2e8f0;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 2rem;
}

.title-section {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.page-icon {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.page-title {
  font-size: 2rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 0.5rem;
  letter-spacing: -0.025em;
}

.page-subtitle {
  font-size: 1.125rem;
  color: #64748b;
  margin: 0;
  font-weight: 400;
}

.action-buttons {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.primary-action-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: white;
  border: none;
  padding: 0.875rem 1.5rem;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.2);
  text-decoration: none;
}

.primary-action-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(59, 130, 246, 0.3);
  color: white;
  text-decoration: none;
}

.secondary-action-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: white;
  border: 2px solid #e2e8f0;
  padding: 0.875rem 1.5rem;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
}

.secondary-action-btn:hover {
  background-color: #f8fafc;
  transform: translateY(-1px);
  text-decoration: none;
}

/* Professionals Grid */
.professionals-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 1.5rem;
}

.professional-card {
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 16px;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
}

.professional-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07), 0 1px 3px rgba(0, 0, 0, 0.06);
  transform: translateY(-2px);
}

/* Card Header */
.card-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.card-header:hover {
  background-color: #f8fafc;
}

.professional-avatar {
  position: relative;
  flex-shrink: 0;
}

.avatar-image {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  border: 3px solid #e2e8f0;
  transition: all 0.2s ease;
}

.external-badge {
  position: absolute;
  bottom: -2px;
  right: -2px;
  background: #ef4444;
  color: white;
  font-size: 0.625rem;
  font-weight: 600;
  padding: 0.25rem 0.5rem;
  border-radius: 12px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.professional-info {
  flex: 1;
  min-width: 0;
}

.professional-name {
  margin-bottom: 0.75rem;
}

.professional-name h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 0.25rem;
  line-height: 1.2;
}

.professional-status {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.875rem;
  font-weight: 500;
}

.professional-details {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.detail-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #64748b;
  font-size: 0.875rem;
}

.detail-item svg {
  flex-shrink: 0;
  color: #94a3b8;
}

.detail-item span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.expand-indicator {
  flex-shrink: 0;
  color: #94a3b8;
  transition: transform 0.2s ease;
}

/* Card Actions */
.card-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem 1.5rem;
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
}

.action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: none;
  background: white;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #64748b;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.action-btn:hover {
  background-color: #f1f5f9;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.edit-btn:hover {
  background-color: rgba(59, 130, 246, 0.1);
}

.calendar-btn:hover {
  background-color: rgba(59, 130, 246, 0.1);
}

.mobile-btn:hover {
  background-color: rgba(59, 130, 246, 0.1);
}

.delete-btn {
  color: #ef4444;
}

.delete-btn:hover {
  background-color: rgba(239, 68, 68, 0.1);
}

/* Card Details */
.card-details {
  padding: 1.5rem;
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
  animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.details-grid {
  display: grid;
  gap: 1.5rem;
}

.detail-section {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  border: 1px solid #e2e8f0;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.section-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.section-title {
  font-size: 1rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
}

.tags-container {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.tag {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.5rem 0.75rem;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 500;
  border: 1px solid currentColor;
  transition: all 0.2s ease;
}

.tag:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.location-tag svg,
.specialty-tag svg {
  flex-shrink: 0;
}

/* Loading State */
.loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
}

.loading-content {
  text-align: center;
  max-width: 400px;
}

.loading-content h3 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1e293b;
  margin: 1rem 0 0.5rem;
}

.loading-content p {
  color: #64748b;
  margin: 0;
  line-height: 1.6;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .professionals-container {
    padding: 1rem;
  }
  
  .professionals-grid {
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  }
  
  .header-content {
    flex-direction: column;
    align-items: stretch;
    gap: 1.5rem;
  }
  
  .action-buttons {
    justify-content: center;
  }
}

@media (max-width: 768px) {
  .professionals-container {
    padding: 0.5rem;
  }
  
  .page-header {
    padding: 1.5rem;
  }
  
  .title-section {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }
  
  .page-icon {
    width: 48px;
    height: 48px;
  }
  
  .page-title {
    font-size: 1.5rem;
  }
  
  .page-subtitle {
    font-size: 1rem;
  }
  
  .professionals-grid {
    grid-template-columns: 1fr;
  }
  
  .card-header {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }
  
  .professional-info {
    text-align: center;
  }
  
  .detail-item {
    justify-content: center;
  }
  
  .action-buttons {
    flex-direction: column;
    width: 100%;
  }
  
  .primary-action-btn,
  .secondary-action-btn {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .professionals-container {
    padding: 0.25rem;
  }
  
  .page-header {
    padding: 1rem;
  }
  
  .card-header {
    padding: 1rem;
  }
  
  .card-actions {
    padding: 1rem;
    justify-content: center;
  }
  
  .card-details {
    padding: 1rem;
  }
  
  .detail-section {
    padding: 1rem;
  }
  
  .tags-container {
    justify-content: center;
  }
  
  .tag {
    font-size: 0.75rem;
    padding: 0.375rem 0.625rem;
  }
}

/* Accessibility */
@media (prefers-reduced-motion: reduce) {
  .professional-card,
  .action-btn,
  .tag,
  .expand-indicator {
    transition: none;
  }
  
  .card-details {
    animation: none;
  }
}

/* Focus States */
.action-btn:focus,
.primary-action-btn:focus,
.secondary-action-btn:focus {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}

.card-header:focus {
  outline: 2px solid #3b82f6;
  outline-offset: -2px;
}

/* High Contrast Mode */
@media (max-width: 1200px) {
  .column-right {
    padding-left: 0px;
  }

  .professional-card {
    border-color: #000;
  }
  
  .tag {
    border-width: 2px;
  }
  
  .action-btn {
    border: 1px solid currentColor;
  }
}
</style>